exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-table[data-v-efa6f778] {\n  margin-bottom: 0.03125rem;\n}\n.wl-btn-container[data-v-efa6f778] {\n  height: 0.25rem;\n  padding: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}", ""]);

// exports
